<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Veículos do Endosso
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          TIPO DE ENDOSSO
          <p>{{ getTipoEndosso(this.idTipoEndosso) }}</p>
        </v-flex>
        <v-flex row wrap> CÓD. COTAÇÃO ENDOSSO </v-flex>
        <v-flex> N. PROPOSTA / ENDOSSO </v-flex>
        <v-flex>DIAS DE VIGÊNCIA ENDOSSO </v-flex>
        <v-flex>RAZÃO SOCIAL </v-flex>
        <v-flex> CNPJ </v-flex>

        <v-flex>
          <br />
        </v-flex>
        <v-flex> QTD. ÍTENS EXCLUSÃO </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-layout>
    </v-flex>
    <v-container pa-5 class="background data-table">
      <v-card elevation="0">
        <v-card-title>
          <v-flex xs12 sm11 md6 lg4>
            <transition name="fade">
              <v-flex xs1 v-if="!filtro.pesquisa.opened">
                <v-btn
                  v-if="!filtro.pesquisa.opened"
                  @click="filtroFunctions().abrirFiltroPesquisa()"
                  color="primary"
                  round
                  outline
                  icon
                  ><v-icon>search</v-icon></v-btn
                >
              </v-flex>
              <v-flex v-else>
                <v-text-field
                  v-model="filtro.pesquisa.conteudo"
                  prepend-icon="search"
                  @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                  @blur="filtroFunctions().fecharFiltroPesquisa()"
                  label="Busca"
                  autofocus
                  clearable
                ></v-text-field>
              </v-flex>
            </transition>
          </v-flex>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <v-btn
            color="error"
            round
            :disabled="selected.length === 0 || selecaoBloqueada"
            @click="excluirItem(selected)"
          >
            EXCLUIR ÍTENS: {{ selected.length }}
          </v-btn>
        </v-card-title>
      </v-card>
      <template>
        <div class="table-width">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="veiculoList"
            :pagination.sync="pagination"
            :total-items="pagination.totalItems"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td
                v-if="!camposDisabled"
                :active="props.selected"
                :class="{'removido-endosso': props.item.itemEndossoRemovido}"
                @click="!selecaoBloqueada && (props.selected = !props.selected)"
                :style="
                  props.item.itemEndossoRemovido ||
                  itemRemovidoList.includes(props.item.item)
                    ? { color: '#fff', backgroundColor: '#ffbdb6' }
                    : { color: '#757575' }
                "
              >
                <v-checkbox
                  class="checkbox"
                  color="primary"
                  :class="{ 'checkbox-removido': props.item.itemEndossoRemovido }"
                  :input-value="props.selected"
                  hide-details
                  :disabled="camposDisabled || selecaoBloqueada"
                ></v-checkbox>
              </td>
              <td
                v-for="([texto, atributos], index) in colunas(props.item)"
                :key="index"
                v-bind="atributos"
                :class="[
                  'click',
                  ...(atributos.class || []),
                  { 'removido-endosso':
                      props.item.itemEndossoRemovido ||
                      itemRemovidoList.includes(props.item.item) }
                  ]"
                :style="
                  props.item.itemEndossoRemovido ||
                  itemRemovidoList.includes(props.item.item)
                    ? { color: '#fff', backgroundColor: '#ffbdb6' }
                    : { color: '#757575' }
                "
              >
                {{ texto }}
              </td>
            </template>
          </v-data-table>
        </div>
      </template>
      <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-flex>
        <v-btn class="button-custom" :disabled="proximoDisabled()" type="submit" @click="proximo" flat>
          Próximo
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialog" max-width="600px">
          <ModalEndossos
            v-if="dialog"
            :dialog="dialog"
            :idApolice="idApolice"
            @fecharDialogoEndosso="dialog = false"
          />
        </v-dialog>
      </v-layout>
    </template> -->
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import { adicionarId } from "@/helpers/url-helper.js";
import ModalEndossos from "./ModalEndosso.vue";
import CustomFormat from "@/helpers/custom-format";
import statusEndossoEnum from "@/helpers/status-endosso-enum.js";

export default {
  name: "GridEndossoVeiculoExclusao",
  components: {
    ModalEndossos
  },
  data() {
    return {
      endossoCompletoAtual: null,
      itensExcluidos: false,
      selecaoBloqueada: false,
      idEndossoRascunhoSalvo: null,
      listaApolice: [],
      listaRemovidosRascunho: [],
      itemRemovidoList: [],
      listaRascunho: [],
      idRascunhoEndosso: null,
      loading: true,
      apagarIten: [],
      idTipoEndosso: null,
      veiculoList: [],
      camposDisabledData: false,
      selected: [],
      quantItens: null,
      diasVigencia: null,
      idApolice: null,
      filtrarErros: false,
      snack: false,
      snackColor: "",
      snackText: "",
      dialog: false,
      dialogAvaliando: false,
      dialogConfirmacao: false,
      idStatusEndosso: null,
      pagination: {
        sortBy: "name",
        totalPages: null,
        rowsPerPage: 10,
        page: 1
      },
      regras: {
        notNull: [v => !!v || "Você não pode deixar este campo em branco"]
      },
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: ""
        }
      },
      resultados: {
        totalPremio: null
      },
      chassis: [],
      chassiQtdPassageiros: [],
      veiculosList: [],
      codigoSistemaRastreamentoList: [],
      lista: [],
      endosso: {},
      headers: [
        { text: "", value: "", sortable: false },
        { text: "ITEM", align: "center", value: "item" },
        {
          text: "PLACA",
          align: "center",
          value: "placa"
        },
        { text: "CHASSI", align: "center", value: "chassi" },
        { text: "FIPE", align: "center", value:"fipe", style: "width: 100px" },
        { text: "MARCA", align: "center", value:"marca" },
        { text: "MODELO ", align: "center", value:"modelo" },
        { text: "TIPO VEÍCULO", align: "center", value:"tipoVeiculo" },
        { text: "CAT. VEÍCULO", align: "center", value:"catVeiculo" },
        { text: "ANO FAB.", align: "center", value:"anoFab" },
        { text: "ANO MOD.", align: "center", value:"anoMod" },
        { text: "UF PERNOITE", align: "center", value:"ufPernoite" },
        { text: "USO DO VEÍCULO", align: "center", value:"usoDoVeiculo" },
        {
          text: "PROPRIEDADE (REGISTRO DO CRLV)",
          align: "center",
          value:"propriedadeRegistroDoCrlv"
        },
        { text: "PROPRIETÁRIO", align: "center", value:"proprietario" },
        { text: "CPF/CNPJ", align: "center", value:"cpfCnpj" },
        { text: "NOME SOCIAL", align: "center", value:"nomeSocial" },
        { text: "CHASSI REMARCADO", align: "center", value:"chassiRemarcado" },
        { text: "ZERO KM", align: "center", value:"zeroKm" },
        { text: "SAÍDA CONCESSIONÁRIA", align: "center", value:"saidaDaConcessionaria" },
        { text: "QUANT PASSAGEIROS", align: "center", value:"quantPassageiros" },
        { text: "DISPOSITIVO DE SEGURANÇA", align: "center", value:"codigoSistemaRastreamento"},
      ],
      idPropostaStatus: null
    };
  },
  computed: {
    bloqueiaSelecaoGlobal() {
      return !!this.numeroRevisao;
    },
    camposDisabled() {
      return (
        (this.idStatusEndosso > statusEndossoEnum.statusEndosso.SALVO &&
          this.idStatusEndosso != statusEndossoEnum.statusEndosso.PENDENTE) ||
        this.idPropostaStatus == 7 ||
        this.idPropostaStatus == 12
      );
    },
  },
  watch: {
    'pagination.page'() {
      this.buscarVeiculosParaExclusao();
    },
    'pagination.rowsPerPage'() {
      this.buscarVeiculosParaExclusao();
    },
    'pagination.sortBy'() {
      this.buscarVeiculosParaExclusao();
    },
  },
  mounted() {
    this.endossoCompletoAtual = this.$store.getters["formEndosso/infoEndosso"];
    this.estaNoStatusSalvo = this.endossoCompletoAtual.idStatusEndosso === 1;
    this.idEndossoRascunhoSalvo = this.endossoCompletoAtual.idEndossoRascunhoSalvo
      ? this.endossoCompletoAtual.idEndossoRascunhoSalvo
      : null;
    this.idStatusEndosso = !Number.isNaN(parseInt(this.$route.query.idStatusEndosso))
      ? parseInt(this.$route.query.idStatusEndosso)
      : this.endossoCompletoAtual.idStatusEndosso;
    this.endossoCompletoAtual.idStatusEndosso;
    this.idRascunhoEndosso = this.$route.query.idRascunhoEndosso;
    this.idTipoEndosso = this.$route.query.idTipoEndosso;
    this.numeroRevisao = !Number.isNaN(parseInt(this.$route.query.numeroRevisao))
      ? parseInt(this.$route.query.numeroRevisao)
      : this.idEndossoRascunhoSalvo;
    this.idApolice = parseInt(this.$route.query.id);
    this.idPropostaStatus = this.$route.query.idPropostaStatus
      ? this.$route.query.idPropostaStatus
      : null;
    if (this.idRascunhoEndosso == undefined) {
      this.veiculoList = this.$store.getters[
        "formEndosso/cloneConteudoPlanilha"
      ];
    }
    if (this.$route.query.id) {
      const idEndosso = decodeURIComponent(this.$route.query.id || "").trim();
      if(idEndosso) {
        this.buscarEndosso(idEndosso);
      }
    }

    if (this.estaNoStatusSalvo) {
      this.buscarVeiculosItensModificados();
    } else {
      this.buscarVeiculosParaExclusao();
    }
  },
  methods: {
    proximoDisabled() {
        if (!this.numeroRevisao) {
          return false;
        }
        return this.itensExcluidos !== true;
    },
    isItemRemovido(item) {
      return (
        item.itemEndossoRemovido == true ||
        this.itemRemovidoList.includes(item.item)
      );
    },
    isCheckboxDisabled(item) {
      return (
        this.camposDisabled ||
        this.bloqueiaSelecaoGlobal ||
        this.isItemRemovido(item)
      );
    },
    isItemSelected(props) {
      return props.selected || this.isItemRemovido(props.item);
    },
    async buscarVeiculosItensModificados() {
      this.loading = true;
      this.$store.commit("startLoading");
      await axios
        .get(`${process.env.URL_APOLICEMS}/v1/buscarVeiculosItensModificados/${this.idApolice}/${this.idEndossoRascunhoSalvo}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.itemRemovidoList = response.data;
        })
        .catch(err => {
          this.$store.commit("endLoading");
        })
        .finally(() => {
          this.$store.commit("endLoading");
          this.loading = false;
        });
    },

    async buscarNumPassageiro(chassis){
      const chassiModel = {
        chassis: chassis
      }
      var response = await axios.post(
        `${process.env.URL_APOLICEMS}/v1/buscarNumeroPassageiro/`,chassiModel,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.chassiQtdPassageiros = response.data

    },

    async buscarEndosso(idEndosso) {
      const response = await axios.get(
        `${process.env.URL_APOLICEMS}/v1/listarVeiculos/${idEndosso}?page=${this.pagination.page - 1}&size=${this.pagination.rowsPerPage}&ignore=&idTipoEndosso=${this.idTipoEndosso}${this.numeroRevisao ? `&numeroRevisaoEndosso=${this.numeroRevisao}` : ''}`,
        {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        }
      );
      this.endosso = response.data.content;
      this.veiculoList = response.data.content;

      this.pagination.totalItems = response.data.totalElements;

      this.dateInicio = this.endosso.dateInicio;
      this.itemRemovidoList = this.endosso.filter(e => e.itemEndossoRemovido === true).map(e => e.item);
      this.selected = this.veiculoList.filter(
        item => item.itemEndossoRemovido === true
      );
    },

    storageItemExclusao() {
      var veiculoList = {
        dados: this.itemRemovidoList
      };
      var veiculoRestanteList = {
        dados: this.veiculoList
      };

      veiculoRestanteList.dados.forEach(item => {
        if (item.itemEndossoRemovido) {
          item.itemEndossoRemovido = false;
        }
      });

      this.$store.commit("formEndosso/dadosItemExclusao", veiculoList);
      this.$store.commit(
        "formEndosso/dadosItensRestantes",
        veiculoRestanteList
      );
    },

    excluirItem(itens) {
      itens.forEach(item => {
        item.itemEndossoRemovido = true;
      });
      this.itemRemovidoList = [...new Set([...this.itemRemovidoList, ...itens.map(e => e.item)])]
      this.veiculosList.push(...itens);
      const selecionados = this.selected.map(e => e.item);
      if (this.idRascunhoEndosso) {
        this.listaApolice = this.listaApolice.filter(
          e => !selecionados.includes(e.item)
        );
      } else {
        this.veiculoList = this.veiculoList.filter(
          e => !selecionados.includes(e.item)
        );
      }
      this.itensExcluidos = true;
      this.selected = [];
    },

    getTipoEndosso(idTipoEndosso) {
      if (idTipoEndosso == 1) return "COBRANÇA";
      else if (idTipoEndosso == 2) return "RESTITUIÇÃO";
      else if (idTipoEndosso == 3) return "SEM MOVIMENTAÇÃO";
      else if (idTipoEndosso == 4) return " CANCELAMENTO";
    },

    async buscarVeiculosParaExclusao() {
        this.loading = true;
        this.$store.commit("startLoading");
        const idEndosso = decodeURIComponent(this.$route.query.id || "").trim();
        await axios
          .get(`${process.env.URL_APOLICEMS}/v1/listarVeiculos/${idEndosso}` +
              `?page=${this.pagination.page - 1}` +
              `&size=${this.pagination.rowsPerPage}` +
              `&ignore=${this.itemRemovidoList.join(",")}` +
              (this.idTipoEndosso ? `&idTipoEndosso=${this.idTipoEndosso}` : '') +
              (this.numeroRevisao ? `&numeroRevisaoEndosso=${this.numeroRevisao}` : ''),
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          )
          .then(response => {
            this.veiculoList = response.data.content;
            this.pagination.totalItems = response.data.totalElements;

            for(var chassi of this.veiculoList){
              this.chassis.push(chassi.chassi)
            }
            this.buscarNumPassageiro(this.chassis)
            this.filtroFunctions().aplicarFiltros();
            this.selected = this.veiculoList.filter(
              item => item.itemEndossoRemovido === true
            );
            this.$store.commit("endLoading");
          })
          .catch(err => {
            this.$store.commit("endLoading");
          })
          .finally(() => {
            this.loading = false;
          });
    },

    colunas(item) {
      return [
        [this.formatarNumeroItem(item.item), { class: "pa-4 text-align-center" }],
        [item.placa || '-', { class: "text-align-center"}],
        [item.chassi || '-', { class: "pa-4 text-align-center" }],
        [item.fipe || '-', { class: "pa-4 text-align-center" }],
        [item.marca || '-', { class: "pa-4 text-align-center" }],
        [item.modelo || '-', { class: "text-align-center" }],
        [item.tipoVeiculo || '-', { class: "text-align-center" }],
        [item.catVeiculo || '-', { class: "text-align-center" }],
        [item.anoFab || '-', { class: "text-align-center" }],
        [item.anoMod || '-', { class: "text-align-center" }],
        [item.ufPernoite || '-', { class: "text-align-center" }],
        [item.usoDoVeiculo || '-', { class: "text-align-center" }],
        [item.propriedadeRegistroDoCrlv || '-', { class: "text-align-center" }],
        [item.proprietario || '-', { class: "text-align-center" }],
        [item.cpfCnpj || '-', { class: "text-align-center" }],
        [item.nomeSocial || '-', { class: "text-align-center" }],
        [this.traduzValor(item.chassiRemarcado), { class: "text-align-center" }],
        [this.traduzValor(item.zeroKm), { class: "text-align-center" }],
        [item.saidaDaConcessionaria || '-', { class: "text-align-center" }],
        [this.buscarQuantPassageiro(item.chassi), { class: "text-align-center" }],
        [this.traduzValor(item.codigoSistemaRastreamento), { class: "text-align-center" }],
      ];
    },

    buscarQuantPassageiro(chassi){
      for(var quant of this.chassiQtdPassageiros){
        if(quant.nrChassi === chassi){
          return quant.nrQtdPax
        }
      }
    },

    traduzValor(value) {
      if (value === true) {
        return (value = "Sim");
      } else {
        return (value = "Não");
      }
    },

    contarData() {
      const dataAtual = new Date();
      const dataFimVigencia = new Date(this.endosso.dataFim);
      const contagem = dataFimVigencia.getTime() - dataAtual.getTime();
      this.diasVigencia = Math.floor(contagem / 8.64e7);
    },

    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    },

    formatStatusEndosso(status) {
      if (status == 1) return "SALVO";
      if (status == 2) return "EMITIDA";
      if (status == 3) return "AG. ENDOSSO";
      if (status == 4) return "ENDOSSO APROVADO";
      if (status == 5) return "ENDOSSO REPROVADO";
    },

    formatTipoEndosso(tipo) {
      if (tipo == 1) return "COBRANÇA";
      if (tipo == 2) return "RESTITUIÇÃO";
      if (tipo == 3) return "SEM MOVIMENTAÇÃO";
      if (tipo == 4) return "CANCELAMENTO";
    },

    somaNumeros(numeros) {
      let soma = 0;
      for (let i = 0; i < numeros.length; i++) {
        soma += numeros[i].itemExcInc;
      }
      return soma;
    },

    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },

    formatarData(data) {
      if (data) {
        return new Date(data).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "numeric",
          day: "numeric"
        });
      }
    },

    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    deletarItens() {
      const selecionados = this.selected.map(e => e.item);
      this.veiculoList = this.veiculoList.filter(
        e => !selecionados.includes(e.item)
      );
    },

    filtroFunctions: function() {
      const self = this;
      return {
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        }
      };
    },

    voltar: function() {
      if (this.idRascunhoEndosso) {
        this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idRascunhoEndosso=${this.idRascunhoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else if(this.idRascunhoEndosso == undefined && this.estaNoStatusSalvo) {
        this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idStatusEndosso=${this.idStatusEndosso}&idPropostaStatus=${this.idPropostaStatus}${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }`
        );
      } else {
        this.$router.push(
          `/GridPrincipal/InfoEndosso?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }`
        );
      }
    },

    proximo() {
      this.storageItemExclusao();
      if (this.idRascunhoEndosso) {
        this.$router.push(
          `/GridPrincipal/CoberturaEndossoExclusao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idRascunhoEndosso=${this.idRascunhoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else if(this.idRascunhoEndosso == undefined && this.idStatusEndosso == 1) {
        this.$router.push(
          `/GridPrincipal/CoberturaEndossoExclusao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idStatusEndosso=${this.idStatusEndosso}&idPropostaStatus=${this.idPropostaStatus}${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }`
        );
      } else {
        this.$router.push(
          `/GridPrincipal/CoberturaEndossoExclusao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }`
        );
      }
    },

    formatarNumeroCotacao(item) {
      if (item != null) {
        const numero = `000000${item}`;
        return numero.slice(numero.length - 6);
      }
    }
  }
};
</script>

<style>
  .background {
    background-color: white;
  }

  .table-width > div > div > table {
    width: 3000px;
  }

  .item-color > div > a {
    color: #757575 !important;
  }

  .activeError {
    border: 1px solid red;
    color: red !important;
  }

  .button-permanecer {
    background: #00456e;
    color: white !important;
  }

  .text-permanecer {
    font-weight: bold;
    color: #757575 !important;
  }
  .errorTaxa {
    color: red !important;
    font-weight: bold;
  }
  .button-custom {
    width: 100%;
    max-width: 121px;
    text-align: center;
    color: #fff !important;
    background-color: #00456e;
    border-radius: 2px;
    display: inline-block;
    padding: 9px 12px;
    cursor: pointer;

    font-weight: bold;
  }
  .button-custom:hover {
    background-color: #063f57;
  }

  .disabled,
  .v-btn.button-custom:disabled {
    cursor: default;
    background-color: #063f57;
    color: #aaaaaa !important;
  }

  .disabled:hover {
    background-color: #063f57;
  }

  .text-align-center {
    text-align: center;
  }

.removido-endosso {
  color: #fff !important;
  background-color: #ffbdb6 !important;
}

.checkbox-removido .v-icon {
  background-color: #ffbdb6!important;
}

.checkbox-removido .v-input--selection-controls__ripple {
  color: #ffbdb6 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/GridEndossoVeiculoExclusao.vue